import { Injectable } from "@angular/core";
import { CanActivate, Resolve, UrlTree } from "@angular/router";
import { UserService } from "app/core/services/admin/user/user.service";
import { ACL } from "app/shared/models/acl";
import { Observable } from "rxjs";
import { RoleService } from "../../../../../core/services/admin/role/role.service";

@Injectable()
export class RoleListGuard implements CanActivate, Resolve<any> {
    constructor(private _service: RoleService, private _userService: UserService) {}

    resolve() {
        return this._service.getAll();
    }
    canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return (this._userService.getUserAclFromToken() as ACL).SYSPAD_ADMIN_ROLE_LIST === 1;
    }
}
